import { render } from "./CheckmarkItem.vue?vue&type=template&id=ec106088&scoped=true"
import script from "./CheckmarkItem.vue?vue&type=script&lang=js"
export * from "./CheckmarkItem.vue?vue&type=script&lang=js"

import "./CheckmarkItem.vue?vue&type=style&index=0&id=ec106088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec106088"]])

export default __exports__